var map = {
	"./Callcenter/Assets/js/index.js": "oBO1",
	"./Calls/Assets/js/index.js": "zHJT",
	"./Campaigns/Assets/js/index.js": "sUrq",
	"./CustomerChat/Assets/js/index.js": "9Kz6",
	"./Dialer/Assets/js/index.js": "quQK",
	"./DoNotCall/Assets/js/index.js": "fIl/",
	"./FacebookChat/Assets/js/index.js": "gaU6",
	"./GsmTrackers/Assets/js/index.js": "p4eE",
	"./Mails/Assets/js/index.js": "Zyqf",
	"./Menu/Assets/js/index.js": "qwgL",
	"./Notifications/Assets/js/index.js": "J6jf",
	"./Phonebook/Assets/js/index.js": "PuhI",
	"./Player/Assets/js/index.js": "RToz",
	"./Polls/Assets/js/index.js": "NPTG",
	"./Queues/Assets/js/index.js": "j/4/",
	"./Reporting/Assets/js/index.js": "wyb6",
	"./Settings/Assets/js/index.js": "amv3",
	"./Sms/Assets/js/index.js": "5qs2",
	"./Ticketing/Assets/js/index.js": "1XhZ",
	"./User/Assets/js/index.js": "2SLw",
	"./Voicemails/Assets/js/index.js": "qZa1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19IZ";